/**
 * Navigation Configuration
 * Single source of truth for navigation items across the app
 */

export const NAVIGATION_ITEMS = [
  {
    path: '/library',
    label: 'Library',
    title: 'Music Library',
    requiresAuth: true,
  },
  {
    path: '/dashboard',
    label: 'Dashboard',
    title: 'Dashboard',
    requiresAuth: true,
    hidden: true,
  },
  {
    path: '/storage',
    label: 'Upload',
    title: 'Upload Music',
    requiresAuth: true,
  },
  {
    path: '/services',
    label: 'Services',
    title: 'Music Services',
    requiresAuth: true,
  },
  {
    path: '/roadtrip',
    label: 'Listen party',
    title: 'Listen party',
    requiresAuth: true,
  },
  {
    path: '/puzzleparty',
    label: 'Puzzle',
    title: 'Puzzle',
    requiresAuth: true,
    hidden: true,
  },
  {
    path: '/notebooklm',
    label: 'NBLM',
    title: 'NBLM',
    requiresAuth: true,
    hidden: true,
  },
  {
    path: '/mapping',
    label: 'Map',
    title: 'Map',
    requiresAuth: true,
  },
  {
    path: '/patent',
    label: 'Patent',
    title: 'Patent Application (NDA Required)',
    requiresAuth: true,
    hidden: true,
  },
  {
    path: '/members',
    label: 'Members',
    title: 'Members',
    requiresAuth: true,
  },
  {
    path: 'http://localhost:3001',
    label: 'Metadata',
    title: 'Metadata Update Manager (opens in new tab)',
    requiresAuth: true,
    external: true,
    hidden: true,
  },
];

/**
 * Get navigation items filtered by authentication requirement
 * @param {boolean} isAuthenticated - Whether user is authenticated
 * @returns {Array} Filtered navigation items
 */
export function getNavigationItems(isAuthenticated) {
  return NAVIGATION_ITEMS.filter(
    (item) => (!item.requiresAuth || isAuthenticated) && !item.hidden
  );
}
